import { SL } from '@surfline/web-common';

/**
 * @param {Array<{ type: string, planId: string }>} warnings
 */
const filterSubscriptionWarnings = (warnings) =>
  warnings?.filter(({ type, planId }) => {
    if (type === 'invalidZip' || (type === 'failedPayment' && planId.startsWith(SL))) {
      return true;
    }
    return false;
  }) || [];

export default filterSubscriptionWarnings;
